export const isLocation = (location: unknown): location is { lat: number; lon: number } => {
  return (
    typeof location === "object" &&
    location !== null &&
    "lat" in location &&
    "lon" in location &&
    typeof location.lat === "number" &&
    typeof location.lon === "number"
  );
};
